import { render } from "./TablaProfesionalesDisponibles.vue?vue&type=template&id=ef9c0a98&ts=true"
import script from "./TablaProfesionalesDisponibles.vue?vue&type=script&lang=ts"
export * from "./TablaProfesionalesDisponibles.vue?vue&type=script&lang=ts"

import "./TablaProfesionalesDisponibles.vue?vue&type=style&index=0&id=ef9c0a98&lang=scss"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__